import { SUPPORTED_LOCALES } from '../i18n/config';
import { isLaboSukePublicEnabled } from './config';

/** 公開時のラボ助 URL（ja は `/labo-suke`、他言語は `/en/labo-suke` 等） */
export function laboSukePublicPath(locale: string): string {
  if (!isLaboSukePublicEnabled()) return '/labo-suke';
  if (locale === 'ja' || locale.startsWith('ja-')) return '/labo-suke';
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) return `/${locale}/labo-suke`;
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) return `/${short}/labo-suke`;
  return '/labo-suke';
}

export function isLaboSukePublicPathname(pathname: string): boolean {
  if (!isLaboSukePublicEnabled()) return false;
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/labo-suke') return true;
  return SUPPORTED_LOCALES.some((loc) => loc !== 'ja' && path === `/${loc}/labo-suke`);
}
